

const Data = [
    {
      id: 1,
      category: "education",
      icon: "icon-graduation",
      year: "2016 - 2021",
      title: "Bahelor's Degree",
      desc: "Bachelor of Science in Software Engineering.",
    },
    {
      id: 2,
      category: "education",
      icon: "icon-graduation",
      year: "2023 - 2023",
      title: "Certificate",
      desc: "Deep Learning Specialization Coursera.",
    },
    {
      id: 3,
      category: "education",
      icon: "icon-graduation",
      year: "2023 - 2023",
      title: "Certificate",
      desc: "Web Development Bootcamp Udemy.",
    },
    {
      id: 4,
      category: "education",
      icon: "icon-graduation",
      year: "2024 - present",
      title: "Certificate",
      desc: "SOC2 Lead Analyst",
    },
    {
      id: 5,
      category: "experience",
      icon: "icon-briefcase",
      year: "2024 - Present",
      title: "Software Developer Associate",
      desc: "Milima Security.",
    },
    {
      id: 6,
      category: "experience",
      icon: "icon-briefcase",
      year: "2023 - 2024",
      title: "Blockchain Developer",
      desc: "Btrust Builders.",
    },
    {
      id: 7,
      category: "experience",
      icon: "icon-briefcase",
      year: "2017 - Present",
      title: "Software  Engineer",
      desc: "Self-Employed.",
    },
  ];
  export default  Data;
